import styled from 'styled-components'

export const ChartCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
  height: 100%;
  padding: 0.85rem 1rem 0.75rem;
  border-radius: 12px;
  border: 1px solid ${({ theme }) => theme.colors.borderDefault};
  background: ${({ theme }) => theme.colors.background};

  @media (max-width: 768px) {
    padding: 0.75rem 0.85rem 0.65rem;
  }
`

export const ChartHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
`

export const ChartTitle = styled.h3`
  margin: 0;
  font-size: 0.9375rem;
  font-weight: 600;
  letter-spacing: -0.01em;
  color: ${({ theme }) => theme.colors.textPrimary};
`

export const ChartSubtitle = styled.p`
  margin: 0;
  font-size: 0.75rem;
  line-height: 1.45;
  color: ${({ theme }) => theme.colors.textMuted};
`

export const ChartBody = styled.div`
  width: 100%;
  height: 200px;
  min-height: 200px;
  flex-shrink: 0;

  @media (max-width: 768px) {
    height: 180px;
    min-height: 180px;
  }

  .recharts-cartesian-axis-tick-value {
    font-variant-numeric: tabular-nums;
  }
`

export const ChartEmpty = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 0.45rem;
  min-height: 140px;
  padding: 1rem 1rem;
  border-radius: 10px;
  border: 1px dashed ${({ theme }) => theme.colors.borderStrong};
  background: ${({ theme }) =>
    theme.name === 'dark'
      ? theme.colors.background
      : theme.colors.borderSubtle};
`

export const ChartEmptyTitle = styled.span`
  font-size: 0.9375rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.textSecondary};
`

export const ChartEmptyHint = styled.span`
  font-size: 0.8125rem;
  line-height: 1.45;
  color: ${({ theme }) => theme.colors.textMuted};
  max-width: 36rem;
`

export const ChartEmptyActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-top: 0.5rem;
`

export const ChartTooltip = styled.div`
  background: ${({ theme }) => theme.colors.background};
  border: 1px solid ${({ theme }) => theme.colors.borderDefault};
  border-radius: 8px;
  padding: 0.65rem 0.75rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
`

export const ChartTooltipLabel = styled.div`
  font-size: 0.75rem;
  color: ${({ theme }) => theme.colors.textMuted};
  margin-bottom: 0.25rem;
`

export const ChartTooltipValue = styled.div`
  font-size: 0.875rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.textPrimary};
`

export const ErrorMessage = styled.p`
  margin: 0;
  padding: 1rem 1.25rem;
  border-radius: 12px;
  border: 1px solid ${({ theme }) => theme.colors.action.danger.bg}33;
  background: ${({ theme }) =>
    theme.name === 'dark'
      ? 'rgba(220, 38, 38, 0.12)'
      : 'rgba(220, 38, 38, 0.06)'};
  color: ${({ theme }) => theme.colors.action.danger.bg};
  font-size: 0.875rem;
  font-weight: 500;
`
